export default __webpack_public_path__ + "static/media/argos.4c915d80.jpg";